import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  guidePricingApi,
  guidePricingKeys,
  type UpdateGuidePricingPayload,
} from '@/features/guide/api/guide-pricing.api';
import { guidesKeys } from '@/features/guides/api/guides.api';

export function useGuidePricing() {
  return useQuery({
    queryKey: guidePricingKeys.mine(),
    queryFn: () => guidePricingApi.getMine(),
  });
}

export function useGuidePricingHistory(page = 1, limit = 10) {
  return useQuery({
    queryKey: guidePricingKeys.history(page, limit),
    queryFn: () => guidePricingApi.getHistory(page, limit),
  });
}

export function useUpdateGuidePricing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateGuidePricingPayload) => guidePricingApi.update(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: guidePricingKeys.all });
      queryClient.invalidateQueries({ queryKey: guidesKeys.all });
    },
  });
}
